import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-share-container-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './share-container.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class ShareContainerTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<ShareContainerTemplateData>;
}

export type ShareContainerTemplateData = {
  title: string;
  p1: string;
  button_link: string;
  button_text: string;
  footer: string;
  support_email: string;
};

export const ShareContainerTemplateMocks: ShareContainerTemplateData[] = [
  {
    title: 'Example Conatiner 876',
    p1: 'Jack Faraday invited you to review 18 candidate(s)',
    button_link: 'http://recruitee.com',
    button_text: 'Go to shared candidates',
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
